<template>
  <info-box
    :id="id"
    class="tour"
    :title="tour.heading"
    :content="tour.description"
  >
    <div class="tour-link">
      <a :href="tour.link" target="_self" rel="noopener noreferrer">
        {{ tour.linkText }}
      </a>
    </div>
  </info-box>
</template>

<script>
import InfoBox from '../Shared/InfoBox';

export default {
  components: { InfoBox },
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  computed: {
    id() {
      return 'tour-' + this.tour.id;
    }
  }
};
</script>

<style>
.tour .title {
  padding-bottom: 10px;
}

.tour-link {
  margin-top: 2px;
}
</style>
